import { Checkbox, TextField } from "@fluentui/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "@fluentui/react";

const NewSubModality = (props) => {
  console.log("Props in NewSubModality ----->", props);
  const [t] = useTranslation();
  const dropdownStyles = {
    dropdown: { width: 430, broderRadius: 0 },
    dropdownItemsWrapper: {
      maxHeight: "400px",
    },
    title: {
      borderRadius: "7px",
      background: "none",
      height: "32px",
      display: "flex",
      alignItem: "center",
    },
    dropdownItems: {
      selectors: {
        "@media(min-width: 640px)": {
          maxHeight: 300,
        },
      },
    },
  };

  const modalityOptionsFunction = (modalityList) => {
    let options = [];
    modalityList.map((modality) => {
      options.push({ key: modality.id, text: modality.name });
    });
    return options;
  };

  return (
    <>
      {
        <div
          style={{
            padding: "18px",
            height: "330px",
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            justifyContent: "space-around",
          }}
        >
          <div
            className="ms-Grid"
            dir="ltr"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Dropdown
              options={modalityOptionsFunction(props.modalityList)}
              value={props.modalityId}
              placeholder="Select Modality"
              onChange={(e, data) => {
                console.log(e, data);
                props.setModalityId(data.key);
                props.setModalityIdErrorMsg("");
              }}
              label={t("sub-modality.modality")}
              errorMessage={props.modalityIdErrorMsg}
              styles={dropdownStyles}
              required
            />
          </div>
          <div className="ms-Grid" dir="ltr">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <TextField
                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  name="code"
                  placeholder={t("sub-modality.enter-code")}
                  onChange={(value, data) => {
                    console.log(data);
                    props.setServiceCode(data);
                    props.setServiceCodeErrorMsg("");
                  }}
                  style={{ margin: "0 8px" }}
                  value={props.serviceCode}
                  errorMessage={props.serviceCodeErrorMsg}
                  label={t("sub-modality.service-code")}
                  required
                />
              </div>
              <div>
                <TextField
                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  name="code"
                  placeholder={t("sub-modality.enter-name")}
                  onChange={(value, data) => {
                    props.setServiceName(data);
                    props.setServiceNameErrorMsg("");
                  }}
                  value={props.serviceName}
                  errorMessage={props.serviceNameErrorMsg}
                  label={t("sub-modality.service-name")}
                  required
                />
              </div>
            </div>
          </div>
          <div className="ms-Grid" dir="ltr">
            <TextField
              className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
              name="code"
              placeholder={t("sub-modality.enter-expiration-time")}
              onChange={(value, data) => {
                props.setExpirationTime(data);
                props.setExpirationTimeErrorMsg("");
              }}
              value={props.expirationTime}
              errorMessage={props.expirationTimeErrorMsg}
              label={t("sub-modality.expiration-time-mins")}
            />
          </div>
        </div>
      }
    </>
  );
};

export default NewSubModality;
